<template>
    <div
        :class="[
            'progress-journey',
            props.content.innerSpacing.value && 'progress-journey--inner-spacing'
        ]"
    >
        <div
            class="progress-journey__inner"
            :style="{ width: `${calculateQuizProgress(totalQuestions)}%` }"
        >
            <zoe-atom-media
                v-if="mediaIsNotEmpty(content.progressImage)"
                :class="{ 'progress-journey__image--hidden': hideProgressImage }"
                class="progress-journey__image"
                :item="content.progressImage.value"
            />
        </div>
        <transition name="fade">
            <img
                v-if="progressImage"
                :key="progressImage"
                class="progress-journey__end-image"
                :src="progressImage"
            />
        </transition>
    </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed } from 'vue';
import { componentProps } from '../../../../../mixins/component/component';
import { mediaIsNotEmpty } from '../../../../../../../resources/frontend/js/mixins/get-page-data';
import { calculateQuizProgress } from '../../../../../mixins/utils/quiz-progress';
import ZoeAtomMedia from '@atoms/media/v1.0.0/zoe-atom-media.vue';

const store = useStore();

const props = defineProps({
    ...componentProps,
    totalQuestionsOverwrite: {
        type: Number,
        default: null,
    },
    continuousFlowLength: {
        type: Number,
        default: null,
    },
});

const totalQuestions = computed(() => {
    if (props.totalQuestionsOverwrite) return props.totalQuestionsOverwrite;
    if (props.continuousFlowLength) return props.continuousFlowLength;
    return store.state.quiz.totalFlowLength;
});

const currentQuestion = computed(() => {
    return store.state.quiz.questionCount;
});

const progressImage = computed(() => {
    if (currentQuestion.value === 1) {
        return props.content.imageStart.value;
    } else if (currentQuestion.value > 1 && currentQuestion.value <= totalQuestions.value) {
        return props.content.imageMiddle.value;
    } else if (currentQuestion.value > totalQuestions.value) {
        return props.content.imageEnd.value;
    }
});

const hideProgressImage = computed(() => {
    return store.state.quiz.questionCount > store.state.quiz.totalFlowLength;
});

</script>

<style lang="scss" scoped>
@use 'zoe-molecule-progress-journey';

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.progress-journey {
    --background: v-bind('props.content.style.background.value');
    --active-background: v-bind('props.content.style.activeBackground.value');
    --current-question: v-bind('currentQuestion');
    --total-questions: v-bind('totalQuestions');
}
</style>
